import { get, post, put, patch, del } from './client.js';

const base = (wsId) => `/workspaces/${wsId}/saved-views`;

export const list = (wsId) => get(base(wsId));

export const create = (wsId, { name, module, filters, search, columns, sort }) => {
  const body = {
    name,
    entityType: module, // lowercase — matches @IsIn(['people','companies','deals','tasks']) DTO
    filters:    { ...(filters || {}), ...(search ? { search } : {}) },
    isShared:   false,
  };
  if (columns !== undefined) body.columns = columns;
  // sort: { field, dir } | null — stored in backend SavedView.sort (Json?); null omitted
  if (sort && sort.field) body.sort = sort;
  return post(base(wsId), body);
};

export const update = (wsId, viewId, body) => patch(`${base(wsId)}/${viewId}`, body);

export const upsertDefault = (wsId, entityType, columns) =>
  put(`${base(wsId)}/default`, { entityType, columns });

export const remove = (wsId, viewId) => del(`${base(wsId)}/${viewId}`);

/* Backend → frontend shape */
export const normView = (sv) => {
  const f = (typeof sv.filters === 'object' && !Array.isArray(sv.filters)) ? sv.filters : {};
  const { search, ...rest } = f;
  return {
    id:       sv.id,
    memberId: sv.memberId ?? null, // LV-05: ownership tracking — null for SA-created views
    module:   (sv.entityType || '').toLowerCase(), // 'People' → 'people'
    name:     sv.name,
    filters:  rest,
    search:   search || '',
    columns:  Array.isArray(sv.columns) ? sv.columns : null,
    sort:     (sv.sort && typeof sv.sort === 'object' && !Array.isArray(sv.sort) && sv.sort.field) ? sv.sort : null,
  };
};
